import { render, staticRenderFns } from "./SettingsBotThemeHeader.vue?vue&type=template&id=7467f675&"
import script from "./SettingsBotThemeHeader.vue?vue&type=script&lang=js&"
export * from "./SettingsBotThemeHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports